import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-26_01",
  version: "2026.06.26",
  date: "26 Jun 2026",
  sinceCommit: "3f8830d",
  gameplay: [
    {
      text: "**Kael the Unbound** (PvE gauntlet boss 7): fixed Arcane Detonation never firing — the channel now completes and orbs spawn as intended.",
    },
    {
      text: "Kael **Mirror Court**: decoys now match the real Kael visually; only the true Kael keeps the arcane floor sigil. Strike the real one to shatter the illusion early — he keeps firing mirror bolts during the phase.",
    },
    {
      text: "Kael **Spatial Swap**: **0.6s telegraph** (arcane tether to the furthest hero) before the position swap; landing is clamped to the platform and out of pillars.",
    },
    {
      text: "Kael **Arcane Detonation**: orb spacing scales with the shrinking arena and leaves a traversable safe corridor; ground markers show each orb's lethal blast radius while it charges.",
    },
  ],
  skills: [],
};
